<template>
  <div v-if="isCanceled">
    <v-row>
      <v-col>
        <h2 class="error--text">
          {{ $t('appointment.label.cancellation') }}
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.cancellationOrigin') }}:
        </h6>
        <span class="body-2">
          {{
            appointment.cancellation_origin
              ? $t(
                  `appointment.cancellationOrigin.${appointment.cancellation_origin}`
                )
              : '---'
          }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.cancelReason') }}:
        </h6>
        <span class="body-2">
          {{ appointment.cancel_reason ? appointment.cancel_reason : '---' }}
        </span>
      </v-col>
    </v-row>

    <v-divider class="my-8" />
  </div>
</template>

<script>
export default {
  name: 'AppointmentCanceledInfo',

  props: {
    appointment: {
      type: Object,
    }
  },

  computed: {
    isCanceled() {
      return this.appointment.status === 'CANCELED'
    },
  }
}
</script>
